export const TDOE_DATA_DASHBOARD_ORGANIZATION_ID =
  "22a78f5f-a360-49c7-a89c-c939fc137c15";

export const TDOE_CHART_TYPES = {
  PIE: "pie",
  BAR: "bar",
  STACKED_BAR: "stackedBar",
  STACKED_BAR_ROTATED_X_LABEL: "stackedBarRotatedXLabel",
  CLUSTER_BAR: "clusterBar",
  PERIOD_BREAKDOWN: "periodBreakdown",
  PERIOD_BREAKDOWN_ROTATED_X_LABEL: "periodBreakdownRotatedXLabel",
  HORIZONTAL_BAR: "horizontalBar",
  TEACHERS_BY_PERIOD: "teachersByPeriod",
};

export const TDOE_GRADE_LEVELS = {
  PRE_KINDERGARTEN: "Pre-Kindergarten",
  KINDERGARTEN: "Kindergarten",
  FIRST_GRADE: "First Grade",
  SECOND_GRADE: "Second Grade",
  THIRD_GRADE: "Third Grade",
};

export const TDOE_GROUP_BY = {
  DISTRICT: "District",
  GRADE_LEVEL: "GradeLevel",
  ANSWER: "Answer",
};

export const TDOE_DATA_COLLECTION_PERIODS = {
  BOY: "BOY",
  MOY: "MOY",
  EOY: "EOY",
};

export const TDOE_CATEGORIES = {
  CULTURE_OF_LEARNING: "cultureOfLearning",
  CORE_ACTION_1: "coreAction1",
  CORE_ACTION_2: "coreAction2",
  CORE_ACTION_3: "coreAction3",
};

const EOY_PERIOD_BREAKDOWN = `${TDOE_DATA_COLLECTION_PERIODS.BOY},${TDOE_DATA_COLLECTION_PERIODS.MOY},${TDOE_DATA_COLLECTION_PERIODS.EOY}`;
const BOY_TO_EOY = `${TDOE_DATA_COLLECTION_PERIODS.BOY},${TDOE_DATA_COLLECTION_PERIODS.EOY}`;

export const tdoeReportsRegistry = [
  {
    id: "culture-of-learning-summary-rating",
    title: "Culture of Learning: Summary Rating",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "FEA37C3E-9E6D-4E7C-BCC5-A60895DAB20D",
    defaultGroupBy: null,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CULTURE_OF_LEARNING,
  },
  {
    id: "culture-of-learning-summary-rating-by-group",
    title: "Culture of Learning: Summary Rating - Percentage of Teachers Rating Yes",
    chartType: TDOE_CHART_TYPES.BAR,
    questionSurveyTemplateFieldId:
      "FEA37C3E-9E6D-4E7C-BCC5-A60895DAB20D",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CULTURE_OF_LEARNING,
  },
  {
    id: "core-action-1-summary-rating",
    title: "Core Action 1: Summary Rating",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "8D114412-2EA8-40A3-90C4-A06BD00FA0E6",
    defaultGroupBy: null,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_1,
  },
  {
    id: "core-action-1-summary-rating-by-group",
    title: "Core Action 1: Summary Rating - Percentage of Teachers Rating Yes",
    chartType: TDOE_CHART_TYPES.BAR,
    questionSurveyTemplateFieldId:
      "8D114412-2EA8-40A3-90C4-A06BD00FA0E6",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_1,
  },
  {
    id: "boy-core-action-2-summary-rating",
    title: "Core Action 2: Summary Rating",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "35ACB250-8DC6-44FD-8D49-E3D7850585DA",
    defaultGroupBy: null,
    dataCollectionPeriod: TDOE_DATA_COLLECTION_PERIODS.BOY,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
  },
  {
    id: "core-action-2-summary-rating-by-group",
    title: "Core Action 2: Summary Rating - Percentage of Teachers at Each Level",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "35ACB250-8DC6-44FD-8D49-E3D7850585DA",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
  },
  {
    id: "core-action-3-summary-rating",
    title: "Core Action 3: Summary Rating",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "4AECCED5-80BA-4131-82B1-435CCAEBB30B",
    defaultGroupBy: null,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
  },
  {
    id: "core-action-3-summary-rating-by-group",
    title: "Core Action 3: Summary Rating - Percentage of Teachers at Each Level",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "4AECCED5-80BA-4131-82B1-435CCAEBB30B",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
  },
  {
    id: "core-action-2a-state-summary",
    title: "Core Action 2.A — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "1B8F7296-DAFF-44C0-899A-DB8FB6C1585B",
    defaultGroupBy: null,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.A",
  },
  {
    id: "core-action-2a-summary-by-group",
    title: "Core Action 2.A - District/Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "1B8F7296-DAFF-44C0-899A-DB8FB6C1585B",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.A",
  },
  {
    id: "core-action-2b-state-summary",
    title: "Core Action 2.B — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "4B4DC0E8-57EE-441F-8D76-9A9C2324E3F6",
    defaultGroupBy: null,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.B",
  },
  {
    id: "core-action-2b-summary-by-group",
    title: "Core Action 2.B - District/Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "4B4DC0E8-57EE-441F-8D76-9A9C2324E3F6",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.B",
  },
  {
    id: "core-action-2c-state-summary",
    title: "Core Action 2.C — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "66A933F2-351A-49AE-B952-EB8D52EB2159",
    defaultGroupBy: null,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.C",
  },
  {
    id: "core-action-2c-summary-by-group",
    title: "Core Action 2.C - District/Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "66A933F2-351A-49AE-B952-EB8D52EB2159",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.C",
  },
  {
    id: "core-action-2d-state-summary",
    title: "Core Action 2.D — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "B9421AD5-2DE4-4907-9DED-B2B8F2AED4B6",
    defaultGroupBy: null,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.D",
  },
  {
    id: "core-action-2d-summary-by-group",
    title: "Core Action 2.D - District/Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "B9421AD5-2DE4-4907-9DED-B2B8F2AED4B6",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.D",
  },
  {
    id: "core-action-2e-state-summary",
    title: "Core Action 2.E — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "9D4C75A7-B3F1-45F3-9F49-E5B3241A06ED",
    defaultGroupBy: null,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.E",
  },
  {
    id: "core-action-2e-summary-by-group",
    title: "Core Action 2.E - District/Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "9D4C75A7-B3F1-45F3-9F49-E5B3241A06ED",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.E",
  },
  {
    id: "core-action-3a-state-summary",
    title: "Core Action 3.A — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "9FF6F65C-D991-42A1-80B7-9E80F5A2E0C3",
    defaultGroupBy: null,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.A",
  },
  {
    id: "core-action-3a-summary-by-group",
    title: "Core Action 3.A - District/Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "9FF6F65C-D991-42A1-80B7-9E80F5A2E0C3",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.A",
  },
  {
    id: "core-action-3b-state-summary",
    title: "Core Action 3.B — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "8ECDB6FA-5A81-4207-8EF4-126AA737A5B9",
    defaultGroupBy: null,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.B",
  },
  {
    id: "core-action-3b-summary-by-group",
    title: "Core Action 3.B - District/Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "8ECDB6FA-5A81-4207-8EF4-126AA737A5B9",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.B",
  },
  {
    id: "core-action-3c-state-summary",
    title: "Core Action 3.C — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "F4DCD368-3395-42F1-9963-7E7DFB0B1232",
    defaultGroupBy: null,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.C",
  },
  {
    id: "core-action-3c-summary-by-group",
    title: "Core Action 3.C - District/Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "F4DCD368-3395-42F1-9963-7E7DFB0B1232",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.C",
  },
  {
    id: "core-action-2-state-overview",
    title: "Core Action 2: State Overview",
    chartType: TDOE_CHART_TYPES.CLUSTER_BAR,
    questionSurveyTemplateFieldId: null,
    defaultGroupBy: null,
    coreAction: "2",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
  },
  {
    id: "core-action-3-state-overview",
    title: "Core Action 3: State Overview",
    chartType: TDOE_CHART_TYPES.CLUSTER_BAR,
    questionSurveyTemplateFieldId: null,
    defaultGroupBy: null,
    coreAction: "3",
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
  },
  {
    id: "moy-core-action-2-summary-rating-boy-moy-comparison",
    title: "Core Action 2: Summary Rating (BOY vs. MOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "35ACB250-8DC6-44FD-8D49-E3D7850585DA",
    defaultGroupBy: TDOE_GROUP_BY.ANSWER,
    dataCollectionPeriod: `${TDOE_DATA_COLLECTION_PERIODS.BOY},${TDOE_DATA_COLLECTION_PERIODS.MOY}`,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
  },
  {
    id: "eoy-culture-of-learning-state-overview-boy-moy-eoy-comparison",
    title: "Culture of Learning: State Overview (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "FEA37C3E-9E6D-4E7C-BCC5-A60895DAB20D",
    defaultGroupBy: TDOE_GROUP_BY.ANSWER,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CULTURE_OF_LEARNING,
  },
  {
    id: "eoy-culture-of-learning-district-overview-boy-moy-eoy-comparison",
    title:
      "Culture of Learning: District Overview — Percentage of Teachers Rating Yes (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN_ROTATED_X_LABEL,
    questionSurveyTemplateFieldId:
      "FEA37C3E-9E6D-4E7C-BCC5-A60895DAB20D",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CULTURE_OF_LEARNING,
  },
  {
    id: "eoy-culture-of-learning-summary-rating-by-grade-level-boy-moy-eoy-comparison",
    title:
      "Culture of Learning: Summary Rating by Grade Level (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "FEA37C3E-9E6D-4E7C-BCC5-A60895DAB20D",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CULTURE_OF_LEARNING,
  },
  {
    id: "eoy-core-action-1-state-overview-boy-moy-eoy-comparison",
    title: "Core Action 1: State Overview (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "8D114412-2EA8-40A3-90C4-A06BD00FA0E6",
    defaultGroupBy: TDOE_GROUP_BY.ANSWER,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_1,
  },
  {
    id: "eoy-core-action-1-district-overview-boy-moy-eoy-comparison",
    title:
      "Core Action 1: District Overview — Percentage of Teachers Rating Yes (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN_ROTATED_X_LABEL,
    questionSurveyTemplateFieldId:
      "8D114412-2EA8-40A3-90C4-A06BD00FA0E6",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_1,
  },
  {
    id: "eoy-core-action-1-summary-rating-by-grade-level-boy-moy-eoy-comparison",
    title: "Core Action 1: Summary Rating by Grade Level (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "8D114412-2EA8-40A3-90C4-A06BD00FA0E6",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_1,
  },
  {
    id: "eoy-core-action-2-state-overview-boy-moy-eoy-comparison",
    title: "Core Action 2: State Overview (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "35ACB250-8DC6-44FD-8D49-E3D7850585DA",
    defaultGroupBy: TDOE_GROUP_BY.ANSWER,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
  },
  {
    id: "eoy-core-action-2-district-overview",
    title: "Core Action 2: District Overview",
    chartType: TDOE_CHART_TYPES.STACKED_BAR_ROTATED_X_LABEL,
    questionSurveyTemplateFieldId:
      "35ACB250-8DC6-44FD-8D49-E3D7850585DA",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
  },
  {
    id: "eoy-core-action-2-grade-level-overview",
    title: "Core Action 2: Grade Level Overview",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "35ACB250-8DC6-44FD-8D49-E3D7850585DA",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
  },
  {
    id: "eoy-core-action-2a-state-overview-boy-moy-eoy-comparison",
    title: "Core Action 2.A — State Overview (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "1B8F7296-DAFF-44C0-899A-DB8FB6C1585B",
    defaultGroupBy: TDOE_GROUP_BY.ANSWER,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.A",
  },
  {
    id: "eoy-core-action-2a-grade-level-summary-boy-to-eoy",
    title: "Core Action 2.A — Grade Level Summary (BOY to EOY)",
    chartType: TDOE_CHART_TYPES.HORIZONTAL_BAR,
    questionSurveyTemplateFieldId:
      "1B8F7296-DAFF-44C0-899A-DB8FB6C1585B",
    defaultGroupBy: null,
    dataCollectionPeriod: BOY_TO_EOY,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.A",
  },
  {
    id: "eoy-core-action-2a-district-summary",
    title: "Core Action 2.A — District Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "1B8F7296-DAFF-44C0-899A-DB8FB6C1585B",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.A",
  },
  {
    id: "eoy-core-action-2b-state-overview-boy-moy-eoy-comparison",
    title: "Core Action 2.B — State Overview (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "4B4DC0E8-57EE-441F-8D76-9A9C2324E3F6",
    defaultGroupBy: TDOE_GROUP_BY.ANSWER,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.B",
  },
  {
    id: "eoy-core-action-2b-grade-level-summary-boy-to-eoy",
    title: "Core Action 2.B — Grade Level Summary (BOY to EOY)",
    chartType: TDOE_CHART_TYPES.HORIZONTAL_BAR,
    questionSurveyTemplateFieldId:
      "4B4DC0E8-57EE-441F-8D76-9A9C2324E3F6",
    defaultGroupBy: null,
    dataCollectionPeriod: BOY_TO_EOY,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.B",
  },
  {
    id: "eoy-core-action-2b-district-summary",
    title: "Core Action 2.B — District Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "4B4DC0E8-57EE-441F-8D76-9A9C2324E3F6",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.B",
  },
  {
    id: "eoy-core-action-2c-state-overview-boy-moy-eoy-comparison",
    title: "Core Action 2.C — State Overview (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "66A933F2-351A-49AE-B952-EB8D52EB2159",
    defaultGroupBy: TDOE_GROUP_BY.ANSWER,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.C",
  },
  {
    id: "eoy-core-action-2c-grade-level-summary-boy-to-eoy",
    title: "Core Action 2.C — Grade Level Summary (BOY to EOY)",
    chartType: TDOE_CHART_TYPES.HORIZONTAL_BAR,
    questionSurveyTemplateFieldId:
      "66A933F2-351A-49AE-B952-EB8D52EB2159",
    defaultGroupBy: null,
    dataCollectionPeriod: BOY_TO_EOY,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.C",
  },
  {
    id: "eoy-core-action-2c-district-summary",
    title: "Core Action 2.C — District Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "66A933F2-351A-49AE-B952-EB8D52EB2159",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.C",
  },
  {
    id: "eoy-core-action-2d-state-overview-boy-moy-eoy-comparison",
    title: "Core Action 2.D — State Overview (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "B9421AD5-2DE4-4907-9DED-B2B8F2AED4B6",
    defaultGroupBy: TDOE_GROUP_BY.ANSWER,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.D",
  },
  {
    id: "eoy-core-action-2d-grade-level-summary-boy-to-eoy",
    title: "Core Action 2.D — Grade Level Summary (BOY to EOY)",
    chartType: TDOE_CHART_TYPES.HORIZONTAL_BAR,
    questionSurveyTemplateFieldId:
      "B9421AD5-2DE4-4907-9DED-B2B8F2AED4B6",
    defaultGroupBy: null,
    dataCollectionPeriod: BOY_TO_EOY,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.D",
  },
  {
    id: "eoy-core-action-2d-district-summary",
    title: "Core Action 2.D — District Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "B9421AD5-2DE4-4907-9DED-B2B8F2AED4B6",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.D",
  },
  {
    id: "eoy-core-action-2e-state-overview-boy-moy-eoy-comparison",
    title: "Core Action 2.E — State Overview (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "9D4C75A7-B3F1-45F3-9F49-E5B3241A06ED",
    defaultGroupBy: TDOE_GROUP_BY.ANSWER,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.E",
  },
  {
    id: "eoy-core-action-2e-grade-level-summary-boy-to-eoy",
    title: "Core Action 2.E — Grade Level Summary (BOY to EOY)",
    chartType: TDOE_CHART_TYPES.HORIZONTAL_BAR,
    questionSurveyTemplateFieldId:
      "9D4C75A7-B3F1-45F3-9F49-E5B3241A06ED",
    defaultGroupBy: null,
    dataCollectionPeriod: BOY_TO_EOY,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.E",
  },
  {
    id: "eoy-core-action-2e-district-summary",
    title: "Core Action 2.E — District Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "9D4C75A7-B3F1-45F3-9F49-E5B3241A06ED",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
    subIndicator: "2.E",
  },
  {
    id: "eoy-core-action-3-state-overview-boy-moy-eoy-comparison",
    title: "Core Action 3: State Overview (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "4AECCED5-80BA-4131-82B1-435CCAEBB30B",
    defaultGroupBy: TDOE_GROUP_BY.ANSWER,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
  },
  {
    id: "eoy-core-action-3-grade-level-summary-boy-to-eoy",
    title: "Core Action 3: Grade Level Summary (BOY to EOY)",
    chartType: TDOE_CHART_TYPES.HORIZONTAL_BAR,
    questionSurveyTemplateFieldId:
      "4AECCED5-80BA-4131-82B1-435CCAEBB30B",
    defaultGroupBy: null,
    dataCollectionPeriod: BOY_TO_EOY,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
  },
  {
    id: "eoy-core-action-3a-state-overview-boy-moy-eoy-comparison",
    title: "Core Action 3.A — State Overview (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "9FF6F65C-D991-42A1-80B7-9E80F5A2E0C3",
    defaultGroupBy: TDOE_GROUP_BY.ANSWER,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.A",
  },
  {
    id: "eoy-core-action-3a-grade-level-summary-boy-to-eoy",
    title: "Core Action 3.A — Grade Level Summary (BOY to EOY)",
    chartType: TDOE_CHART_TYPES.HORIZONTAL_BAR,
    questionSurveyTemplateFieldId:
      "9FF6F65C-D991-42A1-80B7-9E80F5A2E0C3",
    defaultGroupBy: null,
    dataCollectionPeriod: BOY_TO_EOY,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.A",
  },
  {
    id: "eoy-core-action-3a-district-summary",
    title: "Core Action 3.A — District Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "9FF6F65C-D991-42A1-80B7-9E80F5A2E0C3",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.A",
  },
  {
    id: "eoy-core-action-3b-state-overview-boy-moy-eoy-comparison",
    title: "Core Action 3.B — State Overview (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "8ECDB6FA-5A81-4207-8EF4-126AA737A5B9",
    defaultGroupBy: TDOE_GROUP_BY.ANSWER,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.B",
  },
  {
    id: "eoy-core-action-3b-grade-level-summary-boy-to-eoy",
    title: "Core Action 3.B — Grade Level Summary (BOY to EOY)",
    chartType: TDOE_CHART_TYPES.HORIZONTAL_BAR,
    questionSurveyTemplateFieldId:
      "8ECDB6FA-5A81-4207-8EF4-126AA737A5B9",
    defaultGroupBy: null,
    dataCollectionPeriod: BOY_TO_EOY,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.B",
  },
  {
    id: "eoy-core-action-3b-district-campus-summary",
    title: "Core Action 3.B — District/Campus Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "8ECDB6FA-5A81-4207-8EF4-126AA737A5B9",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.B",
  },
  {
    id: "eoy-core-action-3c-state-overview-boy-moy-eoy-comparison",
    title: "Core Action 3.C — State Overview (BOY/MOY/EOY comparison)",
    chartType: TDOE_CHART_TYPES.PERIOD_BREAKDOWN,
    questionSurveyTemplateFieldId:
      "F4DCD368-3395-42F1-9963-7E7DFB0B1232",
    defaultGroupBy: TDOE_GROUP_BY.ANSWER,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.C",
  },
  {
    id: "eoy-core-action-3c-grade-level-summary-boy-to-eoy",
    title: "Core Action 3.C — Grade Level Summary (BOY to EOY)",
    chartType: TDOE_CHART_TYPES.HORIZONTAL_BAR,
    questionSurveyTemplateFieldId:
      "F4DCD368-3395-42F1-9963-7E7DFB0B1232",
    defaultGroupBy: null,
    dataCollectionPeriod: BOY_TO_EOY,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.C",
  },
  {
    id: "eoy-core-action-3c-district-campus-summary",
    title: "Core Action 3.C — District/Campus Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "F4DCD368-3395-42F1-9963-7E7DFB0B1232",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
    subIndicator: "3.C",
  },
  {
    id: "eoy-core-action-3-district-overview",
    title: "Core Action 3: District Overview",
    chartType: TDOE_CHART_TYPES.STACKED_BAR_ROTATED_X_LABEL,
    questionSurveyTemplateFieldId:
      "4AECCED5-80BA-4131-82B1-435CCAEBB30B",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
  },
  {
    id: "eoy-culture-of-learning-boy-to-eoy-summary-ratings-by-school",
    title: "Culture of Learning: BOY to EOY Summary Ratings",
    chartType: TDOE_CHART_TYPES.TEACHERS_BY_PERIOD,
    questionSurveyTemplateFieldId:
      "FEA37C3E-9E6D-4E7C-BCC5-A60895DAB20D",
    defaultGroupBy: null,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CULTURE_OF_LEARNING,
  },
  {
    id: "eoy-core-action-1-boy-to-eoy-summary-ratings-by-school",
    title: "Core Action 1: BOY to EOY Summary Ratings",
    chartType: TDOE_CHART_TYPES.TEACHERS_BY_PERIOD,
    questionSurveyTemplateFieldId:
      "8D114412-2EA8-40A3-90C4-A06BD00FA0E6",
    defaultGroupBy: null,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_1,
  },
  {
    id: "eoy-core-action-2-boy-to-eoy-summary-ratings-by-school",
    title: "Core Action 2: BOY to EOY Summary Ratings",
    chartType: TDOE_CHART_TYPES.TEACHERS_BY_PERIOD,
    questionSurveyTemplateFieldId:
      "35ACB250-8DC6-44FD-8D49-E3D7850585DA",
    defaultGroupBy: null,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_2,
  },
  {
    id: "eoy-core-action-3-boy-to-eoy-summary-ratings-by-school",
    title: "Core Action 3: BOY to EOY Summary Ratings",
    chartType: TDOE_CHART_TYPES.TEACHERS_BY_PERIOD,
    questionSurveyTemplateFieldId:
      "4AECCED5-80BA-4131-82B1-435CCAEBB30B",
    defaultGroupBy: null,
    dataCollectionPeriod: EOY_PERIOD_BREAKDOWN,
    hasDefinition: true,
    category: TDOE_CATEGORIES.CORE_ACTION_3,
  },
];

